import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { EntityType } from '@src/types';
import { camelCase } from 'lodash';
import { useFields } from 'pe-core-frontend';
import styles from './EmployeeDetails.module.scss';
export const EmployeeDetails = ({ employee }) => {
    const { items: metadata } = useFields({
        clientId: employee.clientId,
        entityType: EntityType.EMPLOYEE,
    });
    if (!metadata)
        return null;
    return (_jsx("div", { children: metadata?.map(field => (_jsxs("div", { className: styles.field, children: [_jsxs(Typography, { variant: 'label2', children: [field.name, ":"] }), _jsx(Typography, { variant: 'label1', weight: '700', children: employee[camelCase(field.code)] || '-' })] }, field.code))) }));
};
